import React from "react";
import $ from 'jquery' 
import PleaseWaitBox from './PleaseWaitBox'
import DeviceDetailContent from './DeviceDetailContent'
import Header from './Header'
import cookie from 'react-cookie'
import { backend } from '../settings'
import { getItemIndexFromArray } from '../helpers'

export default class DeviceDetail extends React.Component {
  

  constructor(props) {
    super(props)
    let token = cookie.load('token')
    this.state = {'token' : token, data: false}  
  }
 
  handleError(error) {
    let errormsg = error
    if (!error.length) { errormsg = "Unknown Error Occured. Server response not received."}
    this.props.history.push({pathname: '/404', info: errormsg})
  }

  getData(device) {
    this.setState({loading: true})

    $.ajax({
        url: backend + '/my/devices',
        headers: {'Authorization': 'Bearer ' + this.state.token},
        dataType: 'json', cache: false, method: 'GET',
        success: function(result) {
          let index = getItemIndexFromArray(result.data, device)
          this.setState({data: result.data, loading: false, index: index})}.bind(this),
        error: function(xhr, status, err) {this.handleError(err)}.bind(this)
    })
  }

  componentWillMount() {
    if (!this.state.token) { window.location.href = backend + '/accounts/login?view=DeviceDetail,' + this.props.match.params.device}
  }
  
  componentDidMount() {

    if (this.props.location.data) {
      this.setState({data: this.props.location.data, index: this.props.location.index})
    }
    else {
      this.getData(this.props.match.params.device)
    }
  }

  componentWillReceiveProps(nextProps) {
    console.log('will rcv props')
    let index = getItemIndexFromArray(this.state.data, nextProps.match.params.device)
    this.setState({index:index})
  }

  render() {

  	let errorDiv = <h3>{this.state.error}</h3>

    return (
      <div>
      <Header data={this.state.data} history={this.props.history} detailView />
	    { this.state.loading && <PleaseWaitBox/> }	
	    { !this.state.loading && this.state.data && <DeviceDetailContent data={this.state.data[this.state.index]} />}
	    { !this.state.loading && this.state.error && errorDiv}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/DeviceDetail.js